export const getHotelDetailsUrl = (isHoliday, hotelId, queryString) => {
    const pageUrl = isHoliday ? '/holidays/hotels/' : '/hotels/';
    return `${pageUrl}${hotelId}${queryString || ''}`;
};
